module.exports = __webpack_public_path__ + "static/media/ee.9b43910c.svg";